











































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PressureModelPo from "@/store/entities/devices/pressure/pressuremodelpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
@Component({
  components: { TreeSelect },
})
export default class CreatePressureModal extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  prssurepo: PressureModelPo = new PressureModelPo();
  loading: boolean = false;
  created() {
    this.areaTree();
    this.getItemDetail();
    this.getSupplier();
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 5;
      });
      info.forEach((ele) => {
        this.$data.potocolType.push({ label: ele.name, value: ele.id });
      });
      let ispl = detaillist.filter((p) => {
        return p.itemId == 3;
      });
      ispl.forEach((ele) => {
        this.$data.ispType.push({ label: ele.name, value: ele.id });
      });
      let device = detaillist.filter((p) => {
        return p.itemId == 17;
      });
      device.forEach((ele) => {
        this.$data.deviceType.push({ label: ele.name, value: ele.id });
      });
      let tran = detaillist.filter((p) => {
        return p.itemId == 13;
      });
      tran.forEach((ele) => {
        this.$data.transferType.push({ label: ele.name, value: ele.id });
      });
      let mt = detaillist.filter((p) => {
        return p.itemId == 7;
      });
      mt.forEach((ele) => {
        this.$data.meterType.push({ label: ele.name, value: ele.id });
      });
    }
  }
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        if (this.prssurepo.isSec == true && this.prssurepo.aesKey == null) {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: this.L("AesKey") + this.L("CanNotBeEmpty"),
            okText: this.L("Yes"),
            cancelText: this.L("No"),
          });
          this.loading = false;
          return;
        }
        await this.$store
          .dispatch({
            type: "pressuremodel/create",
            data: this.prssurepo,
          })
          .then(() => {
            this.loading = false;
            this.prssurepo = new PressureModelPo();
          })
          .catch(() => {
            this.loading = false;
          });
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();

    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  modelRule = {
    areaId: [
      {
        required: true,
        type: "number",
        message: this.L("Areas") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Name") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    protocol: [
      {
        required: true,
        type: "number",
        message: this.L("Protocol") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    meterType: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    isp: [
      {
        required: true,
        type: "number",
        message: this.L("ISP") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    deviceTypeId: [
      {
        required: true,
        type: "number",
        message:
          this.L("Device") + this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  async areaTree() {
    await this.$store
      .dispatch("area/getAreaSelectTree")
      .then((val) => {
        this.$data.arealist = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async getSupplier() {
    await this.$store
      .dispatch("supplier/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.$data.suppliers.push({ label: ele.name, value: ele.id });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  data() {
    return {
      arealist: [],
      ispType: [],
      potocolType: [],
      meterType: [],
      deviceType: [],
      suppliers: [],
      transferType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
